import React, { useEffect, useState, useContext } from "react";
import Header from "./components/Header";
import StripeForm from "./components/StripeForm";
import ChargeComponent from "./components/ChargeComponent";
import Infos from "./components/Infos";
import ProtectedRoute from "./components/ProtectedRoute";
import StartChargingComponent from "./components/StartChargingComponent";
import ConnectorsComponent from "./components/ConnectorsPlugComponent";
import ResumeSessionComponent from "./components/ResumeSessionComponent";
import SessionLinkComponent from "./components/SessionLinkComponent";
import ErrorComponent from "./components/ErrorComponent";
import HeaderSyder from "./components/HeaderSyder";
import Footer from "./components/Footer";
import { PartnerProvider, PartnerContext } from "./context/PartnerContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./PaymentStyles.css";

const Layout = ({ children }) => {
  const { partner } = useContext(PartnerContext);
  const isSyder = partner === "SYDER";

  return (
    <>
      {isSyder ? <HeaderSyder /> : <Header />}
      {children}
      {isSyder && <Footer />}
    </>
  );
};

const PartnerInitializer = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { ref } = useParams();
  const { setPartner } = useContext(PartnerContext);

  useEffect(() => {
    const isRefPage = /^\/[^/]+$/.test(location.pathname);
    if (isRefPage) {
      const partnerParam = searchParams.get("partner");

      if (partnerParam) {
        localStorage.setItem("partner", partnerParam);
        setPartner(partnerParam);
      } else {
        localStorage.removeItem("partner");
        setPartner(null);
      }
    }
  }, [location.key]);

  return children;
};

function App() {
  const { t } = useTranslation();

  return (
    <PartnerProvider>
      <Router>
        <Routes>
          <Route path="/:ref"
            element={
              <PartnerInitializer>
                <Layout>
                  <ChargeComponent />
                </Layout>
              </PartnerInitializer>
            }
          />
          <Route path="/payment"
            element={
              <Layout>
                <ProtectedRoute>
                  <StripeForm />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route path="/infos"
            element={
              <Layout>
                <Infos />
              </Layout>
            }
          />
          <Route path="/start-charging"
            element={
              <Layout>
                <StartChargingComponent />
              </Layout>
            }
          />
          <Route path="/connectors/:ref"
            element={
              <Layout>
                <ConnectorsComponent />
              </Layout>
            }
          />
          <Route path="/resume-session"
            element={
              <Layout>
                <ResumeSessionComponent />
              </Layout>
            }
          />
          <Route path="/sessions/:sessionToken/resume"
            element={
              <Layout>
                <SessionLinkComponent />
              </Layout>
            }
          />
          <Route path="/error"
            element={
              <Layout>
                <ErrorComponent />
              </Layout>
            }
          />
          <Route path="*"
            element={
              <Navigate
                to="/error"
                replace
                state={{
                  errorText: t("pageNotFound"),
                }}
              />
            }
          />
        </Routes>
      </Router>
    </PartnerProvider>
  );
}

export default App;
